export const QuarteringPage = (destinationLang) => {
  return [
    {
      FormKey: 'page-title-quartering',
      Key: 'ورود و خروج',
      DistinitationLanguage: destinationLang,
    },
  ];
};
